module.exports = __webpack_public_path__ + "static/media/butterfly-editor-v1.0.0.08b6b608.md";